/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

export function addDataLayer(data) {
    window.dataLayer.push(data);
}

export const getBase64Content = (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            if(typeof reader.result == 'string') {
                resolve(reader.result.replace(/^.*base64,/, ""));
            } else {
                reject(null);
            }
        };
        reader.onerror = (error) => {
            reject(error);
        };
    });
};

export const getBrowserName = () => {
    const navigatorname = navigator.browserDetection = (function(){
        var ua= navigator.userAgent, tem, 
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1] || '');
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
            if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
        return M.join(' ');
    })();

    return navigatorname;
};

export const navigateToHelpCenter = (history) => {
    if (history) {
        history.push(`/help-center`);
    }
}